import { render } from "./auth-login.vue?vue&type=template&id=2983d982"
import script from "./auth-login.vue?vue&type=script&lang=js"
export * from "./auth-login.vue?vue&type=script&lang=js"

import "./auth-login.vue?vue&type=style&index=0&id=2983d982&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__